import React from 'react';
import classes from './NewsEventCard.module.scss';
import EllipsisText from "react-ellipsis-text";
import {FormattedMessage} from "react-intl";


const NewsEventCard = (props) => {
    const date = props.date.split(' ')[0];
    const dDay = date.split('-')[2];
    const dMonth = date.split('-')[1];
    const dYear = date.split('-')[0]
    const tempTime = props.date.split(' ')[1];
    const time = tempTime.split(':')[0] + ':' + tempTime.split(':')[1];

    return (
        <div className={classes.Grid_container}>
            <div className={classes.img} style={{backgroundImage: `url(${props.data.image})`}}/>
            <div className={classes.cal}>
                <div className={classes.Cal_card}>
                    <span>{dDay}</span>
                    <span>{dMonth + ' ' + dYear}</span>
                </div>
            </div>
            <div className={classes.title}>
                <h3><EllipsisText text={props.title} length={90}/></h3>
                <span><FormattedMessage id={"global.by"} defaultMessage={"by"}/>&nbsp;{props.author} | {time} | {props.type}</span>
            </div>
            <div className={classes.text}>
                <div dangerouslySetInnerHTML={{__html: `${props.data.introduction.substring(0, 190)} ...`}}/>
            </div>
        </div>
    );
}

export default NewsEventCard;